import { IsMobile, IsTouchScreen } from '@base/utility/BrowserCheck';
import { useMemo } from 'react';

export const useIsMobile = () => {
  return useMemo(() => IsMobile(), []);
};

export const useIsTouchScreen = () => {
  return useMemo(() => IsTouchScreen(), []);
};
